import PropTypes from 'prop-types';
import React from 'react';
import styles from './ContactItem.module.scss.js';

function ContactItem(_ref) {
  var title = _ref.title,
    description = _ref.description,
    contactId = _ref.contactId;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.flex,
    id: contactId
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.grow
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.userName
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, description)));
}
ContactItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired
};

export { ContactItem as default };
